module.exports = __webpack_public_path__ + "static/media/Board_7@2x.7e6ccf9e.png";